import React from "react";
import FormikTextField from "./FormikTextField";

const FormikNumericField = ({ variant, name, label, formik, autoFocus, onBlur, fractionDigits, endAdornment }) => {
  const handleBlur = (event) => {
    if (onBlur) {
      onBlur(event);
    }
  };

  const formatFn = (value) => {
    const formattableValue = value || "0";

    if (fractionDigits) {
      return parseFloat(formattableValue).toFixed(fractionDigits);
    } else {
      return parseInt(formattableValue);
    }
  };

  return (
    <FormikTextField
      variant={variant}
      name={name}
      label={label}
      type="number"
      formik={formik}
      onBlur={handleBlur}
      format={formatFn}
      slotProps={{
        input: {
          type: "number",
          endAdornment,
          step: "1",
        },
      }}
      autoFocus={autoFocus}
    />
  );
}

export default FormikNumericField;